module.exports = __webpack_public_path__ + "img/10_bg.acab05a8.jpg";